import styled from "styled-components";

import colors from "../../assets/css/colors";
import { IContainer } from "./interfaces";

export const Title = styled.h1`
    font: normal normal normal 39px Circular Std Book;
    color: ${colors.primary};
    margin-bottom: 10px;
`;

export const Space = styled.div`
    width: 46px;
`

export const Hr = styled.hr`
    margin-top: 0px;
`

export const Close = styled.button`
    width: 30px;
    height: 30px;
    padding: 0px;
    border: none;
    outline: none;
    background-color: ${colors.white};

    &:focus{
        outline: none;
    }
`;

export const Legend = styled.p`
    line-height: 1;
    margin: 0;
    font: normal normal 600 14px Muli;
    letter-spacing: 0.7px;
    color: ${colors.tertiary};
    margin-bottom: 4px;
`;

export const Info = styled.p`
    line-height: 1;
    margin: 0;
    font: normal normal 600 14px/14px Muli;
    letter-spacing: 0.7px;
    color: ${colors.grayDark};
    margin-bottom: 17px;
`;

export const FieldTitle = styled.h2`
    line-height: 1;
    margin: 0;
    font: normal normal normal 16px Circular Std Book;
    color: ${colors.tertiary};
    margin-bottom: 17px;
`;

export const Row = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 500px){
        display: block;
    }
`;

export const ItemName = styled.p`
    height: 14px;
    line-height: 1;
    display: flex;
    align-items: flex-end;
    font: normal normal 600 14px Muli;
    letter-spacing: 0.7px;
    color: ${colors.grayDark};
    margin: 0;
    margin-right: 17px;
`;

export const DetailsOrDownload = styled.p`
    height: 14px;
    line-height: 1;
    display: flex;
    align-items: flex-end;
    padding-bottom: 1px;
    font: normal normal 600 10px Muli;
    letter-spacing: 0.5px;
    color: ${colors.primary};
    cursor: pointer;
    margin: 0;
`;

export const ProductDetailsContainer = styled.div`
    display: ${(p: IContainer) => p.isOpen ? "block" : "none"};
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 17px 50px 1px 50px;
    background-color: ${colors.grayLightest};
    border-radius: 10px;
`;

export const FirstCol = styled.div`
    width: 200px;
`;

export const SecondCol = styled.div`
    width: 142px;
`;

export const ContainerButton = styled.div`
    margin-top: 10px;
`

export const DialogHeader = styled.div`
    padding: 40px 0 20px 0;
`

export const ThirdCol = styled.div`
    width: 130px;
    position: relative;
`;

export const ProductImage = styled.img`
    width: 120px;
`

export const ContainerDelete = styled.div`
    display: ${(p: IContainer) => p.isOpen ? "block" : "none"};
    position: absolute;
    cursor: pointer;
    top: 5px;
    right: 12px;
    border-radius: 50%;
    padding: 6px;
    background: ${colors.grayLight};
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;

    img {
        width: 18px;
    }
`

export const NotExist = styled.p`
    height: 14px;
    line-height: 1;
    display: flex;
    align-items: flex-end;
    padding-bottom: 1px;
    font: normal normal 600 10px Muli;
    letter-spacing: 0.5px;
    color: ${colors.grayDark};
    cursor: pointer;
    margin: 0;
`;

export const ItemDetailOrDownloadContainer = styled.div`
    display: flex;
    align-items: flex-end;
    margin-bottom: 17px;
`